var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvgSession(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_0_523)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.9873 13.9431L12.9443 18.9591C13.5073 20.4041 15.5773 20.3261 16.0313 18.8431L19.9263 6.11607C20.3103 4.86307 19.1363 3.69007 17.8843 4.07407L5.15731 7.96907C3.67431 8.42307 3.59731 10.4931 5.04131 11.0561L10.0583 13.0131C10.4843 13.1791 10.8213 13.5161 10.9873 13.9431Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#344054"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.00049 20L7.93649 16.849C7.87495 16.6665 7.77208 16.5007 7.63592 16.3646C7.49975 16.2284 7.33396 16.1255 7.15149 16.064L4.00049 15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#344054"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_523"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvgSession);
export default __webpack_public_path__ + "static/media/avg-session.362bf36ed7a20621bb9a026d3a754094.svg";
export { ForwardRef as ReactComponent };